var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPower = function SvgPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m16.188 3.812-.007-.006-.006-.006a.25.25 0 1 1 .353-.353l.006.006.007.007a9.25 9.25 0 0 1 0 13.08 9.25 9.25 0 0 1-13.081 0 9.25 9.25 0 0 1 0-13.08.25.25 0 0 1 .352.353l.354.353-.354-.354a8.75 8.75 0 1 0 12.376 0ZM10 .75a.25.25 0 0 1 .25.25v9a.25.25 0 1 1-.5 0V1A.25.25 0 0 1 10 .75Z"
  })));
};
export default SvgPower;